// src/features/conversation/tableSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    activeStep: 0,
    uploadedFiles: [],
    uploadedFileRes: [],
    uploadedUrls: [],
    loading: false,
    conversationReport: null,
    analysisLoading: false,
    analysisDone: false,
    finalReportUrl: null,
    uiStep: 1,
};

export const tableSlice = createSlice({
    name: "conversation",
    initialState,
    reducers: {
        setUiStep: (state, action) => {
            state.uiStep = action.payload;
        },
        resetUiStep: (state) => {
            state.uiStep = 1;
        },
        setActiveStep: (state, action) => {
            state.activeStep = action.payload;
        },
        nextStep: (state) => {
            state.activeStep += 1;
        },
        previousStep: (state) => {
            state.activeStep -= 1;
        },
        resetStep: (state) => {
            state.activeStep = 0;
        },
        addUploadedFiles: (state, action) => {
            state.uploadedFiles = [
                ...state.uploadedFiles,
                ...action.payload.map((file) => ({
                    name: file.name,
                    size: file.size,
                    type: file.type,
                })),
            ];
        },
        addUploadedFileRes: (state, action) => {
            state.uploadedFileRes = [...state.uploadedFileRes, ...action.payload];
        },
        removeUploadedFile: (state, action) => {
            const index = action.payload;
            const fileToRemove = state.uploadedFiles[index];
            state.uploadedFiles = state.uploadedFiles.filter((_, i) => i !== index);
            state.uploadedFileRes = state.uploadedFileRes.filter(
                (res) => !res.includes(fileToRemove.name)
            );
        },
        clearConversationData: (state) => {
            state.uploadedFiles = [];
            state.uploadedFileRes = [];
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setConversationReport: (state, action) => {
            state.conversationReport = action.payload;
        },
        clearConversationReport: (state) => {
            state.conversationReport = initialState.conversationReport;
        },
        setAnalysisLoading: (state, action) => {
            state.analysisLoading = action.payload;
        },
        setAnalysisDone: (state, action) => {
            state.analysisDone = action.payload;
        },
        setFinalReportUrl: (state, action) => {
            state.finalReportUrl = action.payload;
        },
        setUploadedUrls: (state, action) => {
            state.uploadedUrls = action.payload;
        },
        addUploadedUrl: (state, action) => {
            state.uploadedUrls.push(action.payload);
        },
        resetUploadedUrls: (state) => {
            state.uploadedUrls = [];
        },
        resetConversation: () => initialState,
    },
});

export const {
    setActiveStep,
    nextStep,
    previousStep,
    resetStep,
    addUploadedFiles,
    addUploadedFileRes,
    removeUploadedFile,
    clearConversationData,
    setLoading,
    setConversationReport,
    resetConversation,
    clearConversationReport,
    setAnalysisLoading,
    setAnalysisDone,
    setUiStep,
    resetUiStep,
    setUploadedUrls,
    addUploadedUrl,
    resetUploadedUrls,
    setFinalReportUrl,
} = tableSlice.actions;

export default tableSlice.reducer;
